import React from 'react';
import Box from '@mui/material/Box';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { bool } from 'prop-types';

import AuthActions from '~redux/Auth/actions';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';

function Settings({ hideSettings }) {
  const dispatch = useDispatch();
  const logout = () => dispatch(AuthActions.logout());
  const openSettings = () => dispatch(ModalActions.openModal(MODALS.SETTINGS));

  return (
    <Box
      sx={{
        marginLeft: 'var(--navbar-toolbar-gap)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }}
      className={styles.settingsContainer}>
      {!hideSettings ? (
        <>
          <IconButton className={styles.settingsButton} onClick={openSettings}>
            <SettingsIcon sx={{ fontSize: '24px', color: 'text.secondary' }} />
          </IconButton>
        </>
      ) : null}
      <Box sx={{ color: 'text.secondary' }} className={styles.logoutButton}>
        <Button onClick={logout} variant="text" color="inherit" endIcon={<LogoutIcon />}>
          {i18next.t('NavbarSettings:logout')}
        </Button>
      </Box>
    </Box>
  );
}

Settings.propTypes = {
  hideSettings: bool
};

Settings.defaultProps = {
  hideSettings: false
};

export { Settings };
